var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.listData)?_c('div',{staticClass:"library-default"},[_c('div',{staticClass:"sub-title"},[_vm._v("Danh sách video")]),_vm._v(" "),_c('div',{staticClass:"list-video"},[(!_vm.listData.length)?_c('NoData'):_vm._e(),_vm._v(" "),_vm._l((_vm.listData),function(item){return _c('VideoItem',{key:item.id,attrs:{"item":item}})})],2)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }